export const makeSpacers = () => {
    document.querySelectorAll(".open__desc br,.square__hours-wrap br").forEach(function (br) {
        const spacer = document.createElement("div");
        spacer.className = "spacer";
        br.replaceWith(spacer);
    });

};